import React from 'react';
import { Link, List, Text } from 'basis';
import { useEventTracking } from 'react-event-tracker';
import { useStoreValue } from 'store';
import { getDataLayerElements } from 'utils/getDataLayerElements';
import { OverviewSources } from '_config/_constants/externalLinks';

import groupLFrameCardImage from 'images/premiere-card.png';
// import groupLFrameCardImageMobile from 'images/premiere-card.png';
import groupLFramePrestigeCardImage from 'images/prestige-card.png';
// import groupLFramePrestigeCardImageMobile from 'images/prestige-card.png';
import groupLFrameCardImageNZ from 'images/hero-NZ.png';
import groupLFrameCardImageMobileNZ from 'images/hero-mobile-NZ.png';
import { getRatesAndFees } from 'featureToggles';
import { getConditionsOfUseTerm, getFinancialTableTerm } from 'utils';

const groupLFrameCardImageMobile = groupLFrameCardImage;
const groupLFramePrestigeCardImageMobile = groupLFramePrestigeCardImage;

export const OverviewModalContent = () => ({
  title: 'Gem Visa - Features and benefits',
  body: [
    {
      subtitle: '0% interest for 6 months',
      description:
        'On general purchases of $250 or more when you select your purchases in the Latitude App or Latitude Service Centre within 30 days of the purchase date.',
    },
    {
      subtitle: 'Up to 55 days Interest Free',
      description:
        'You could receive up to 55 days interest free on general purchases made with your Gem Visa if you pay your modified closing balance on each statement by the payment due date.',
    },
    {
      subtitle: 'Long term Gem Visa deals',
      description:
        'We’ve joined with some of New Zealand’s leading brands so you can enjoy long term interest free deals.',
    },
    {
      subtitle: 'Start shopping straight away',
      description:
        'Once approved you can use your Gem Visa account number to access long term interest free deals online or in-store at participating retailers. Or alternatively download the Latitude mobile app and add your Gem Visa into your digital wallet.',
    },
  ],
});

export const OverviewModalContentTwentyEightDegrees = () => {
  return {
    title: 'Credit card features and benefits',
    body: [
      <>
        $0 annual card fee for the first year <strong>(normally $96)</strong>. See other{' '}
        <Link href={OverviewSources.AU.twenty_eight_degrees_rates_fees.url} newTab>
          Rates and Fees{' '}
        </Link>
        here.
      </>,
      'Spend $12,000+ annually on eligible purchases to have your annual card fee waived year after year. T&Cs apply.',
      'Shop and be rewarded with up to $240 in Latitude Rewards when you spend on eligible international and local purchases each month. T&Cs and minimum spend apply.',
      '$0 international transactions or currency conversion fees on purchases online or overseas.',
      'Enjoy a range of credit back offers, discounts and deals from big brands at home and abroad, like Mastercard Priceless Specials, Expedia and Wotif. Exclusions and T&Cs apply.',
      'Complimentary E-Commerce & Purchase Protection Insurance to cover the non-delivery and/or incomplete delivery of your online purchases. T&Cs apply.',
      'Free Flight Delay Pass – Food, drinks and free Wi-Fi in a selection of airport lounges if your flight is delayed 2+ hours. T&Cs apply.',
      'Free Global Data Roaming – 3GB free data each calendar year & 15% off any extra data purchased in over 150 countries. T&Cs apply.',
      'Great foreign exchange rates set by Mastercard, so you get foreign currencies at the same rate we do.',
      'Peace of mind with fraud protection.',
      'Add an additional cardholder at no extra fee.',
      <>
        Before making a decision, please read the{' '}
        <Link
          /* cspell:disable-next-line */
          href={`${OverviewSources.AU.twenty_eight_degrees_key_facts_sheet.url}?gemid2=cc-funnel%3A28degrees%3Aintro%3Alanding%3AKey%2520Facts%2520Sheet%3Awhat-to-expect&_gl=1*ul0ifv*_gcl_aw*R0NMLjE3MjAxNTY2MjMuRUFJYUlRb2JDaE1JdWR5WjNwS1Bod01WdnFWbUFoMW1IQXhTRUFBWUFTQUFFZ0lLdF9EX0J3RQ..*_gcl_dc*R0NMLjE3MjAxNTY2MjMuRUFJYUlRb2JDaE1JdWR5WjNwS1Bod01WdnFWbUFoMW1IQXhTRUFBWUFTQUFFZ0lLdF9EX0J3RQ..*_gcl_au*NTU2OTA2NzA0LjE3MTkxOTUzMjY.*_ga*MTEzOTY5NjIwOC4xNzEyMjgyNzkx*_ga_6ENXTN2K3T*MTcyNDczNzEwOC4xOTkuMS4xNzI0NzM3MzIwLjU1LjAuMA..*_ga_VZY6JWYT4Y*MTcyNDczNzEwOC4xNjQuMS4xNzI0NzM3MzIwLjU1LjAuMA..*_ga_HN02VX7PXM*MTcyNDczNzEwOC4yMDMuMS4xNzI0NzM3MzIwLjU1LjAuMA..`}
          newTab
        >
          Key Facts Sheet
        </Link>{' '}
        and{' '}
        <Link
          /* cspell:disable-next-line */
          href={`${OverviewSources.AU.twenty_eight_degrees_conditions_of_use.url}?gemid2=cc-funnel%3A28degrees%3Aintro%3Alanding%3AConditions%2520of%2520Use%3Awhat-to-expect&_gl=1*1p0gc2t*_gcl_aw*R0NMLjE3MjAxNTY2MjMuRUFJYUlRb2JDaE1JdWR5WjNwS1Bod01WdnFWbUFoMW1IQXhTRUFBWUFTQUFFZ0lLdF9EX0J3RQ..*_gcl_dc*R0NMLjE3MjAxNTY2MjMuRUFJYUlRb2JDaE1JdWR5WjNwS1Bod01WdnFWbUFoMW1IQXhTRUFBWUFTQUFFZ0lLdF9EX0J3RQ..*_gcl_au*NTU2OTA2NzA0LjE3MTkxOTUzMjY.*_ga*MTEzOTY5NjIwOC4xNzEyMjgyNzkx*_ga_6ENXTN2K3T*MTcyNDczNzEwOC4xOTkuMS4xNzI0NzM3NzAzLjYwLjAuMA..*_ga_VZY6JWYT4Y*MTcyNDczNzEwOC4xNjQuMS4xNzI0NzM3NzAzLjYwLjAuMA..*_ga_HN02VX7PXM*MTcyNDczNzEwOC4yMDMuMS4xNzI0NzM3NzAzLjYwLjAuMA..`}
          newTab
        >
          {getConditionsOfUseTerm()}
        </Link>{' '}
        to ensure you're aware of all the fees, charges and interest rates.
      </>,
    ],
  };
};

export const OverviewModalContentLowRate = () => {
  const ratesAndFees = getRatesAndFees();
  return {
    title: 'Credit card features and benefits',
    body: [
      `Get ${ratesAndFees?.rewardRate}% back in Latitude Rewards when you set up recurring payments direct with participating utilities, telco, and streaming services. T&Cs apply.`,
      'Unlock offers and discounts from hundreds of your favourite merchants.',
      `A low rate that rewards you. Get more from your budget with a ${ratesAndFees?.purchaseAnnualRate}% interest rate on general purchases.`,
      'Add an additional cardholder during application to share all the features and benefits at no extra cost.',
      'Complimentary E-Commerce Purchase Insurance to cover the non-delivery and/or incomplete delivery of your online purchases. T&C apply.',
      'Keep your personal and financial information safe from fraud and identity theft with specialist teams that work around the clock.',
      'Rewards, offers, repayments, service and so much more, all in the Latitude App.',
      <>
        Card fee of ${ratesAndFees?.annualFee} per annum (see other{' '}
        <Link href={OverviewSources.AU.latitude_low_rate_mastercard.url} newTab>
          Rates and Fees
        </Link>{' '}
        here).
      </>,
      <>
        Before making a decision, please read the{' '}
        <Link
          /* cspell:disable-next-line */
          href={`${OverviewSources.AU.low_rate_key_facts_sheet.url}`}
          newTab
        >
          key facts sheet
        </Link>
        .
      </>,
    ],
  };
};

export const headerTextDavidJonesPrestige = 'Apply for a David Jones Prestige credit card';
export const headerTextDavidJonesPremiere = 'Apply for a David Jones Premiere credit card';
export const OverviewContent = {
  AU: {
    headerText: 'David Jones Premiere',
    headerIntroText: '',
    formHeader: 'Before you start your application',
    atLeast18: 'Residents of Australia, who are at least 18 years old',
    residentInfo: 'Temporary residents need to hold a visa that’s valid for at least the next 12 months',
    passportOrDriverLicence: 'e.g. Driver licence, Medicare card, Passport',
    proofOfIncome: 'e.g. Sharing your bank statement online or uploading documents',
    showTermsAndConditionsCheckbox: true,
    showLivingExpensesAndUtilitiesInfo: true,
    groupLFrameCardImage,
    groupLFrameCardImageMobile,
    groupLFramePrestigeCardImage,
    groupLFramePrestigeCardImageMobile,
    productInfo: <ProductInfo country="AU" />,
  },
  NZ: {
    headerText: 'Shop better with',
    headerTextLine2: 'Gem Visa credit card',
    headerIntroText: 'Make it yours with a Gem Visa',
    formHeader: 'Before you start your application',
    atLeast18: 'You must be at least 18 years old',
    validInfo: 'Have a valid email address and NZ mobile number',
    residentInfo: 'Be a citizen or reside in New Zealand (for at least the next 12 months)',
    passportOrDriverLicence: 'E.g. NZ drivers licence, NZ Passport, International Passport',
    proofOfIncome: 'E.g. sharing your bank statement online or uploading documents',
    showLivingExpensesAndUtilitiesInfo: true,
    groupLFrameCardImage: groupLFrameCardImageNZ,
    groupLFrameCardImageMobile: groupLFrameCardImageMobileNZ,
    productInfo: <ProductInfo country="NZ" />,
  },
  NZV2: {
    headerText: 'Apply for a Gem Visa credit card',
    headerIntroText: 'Make it yours with a Gem Visa',
    formHeader: 'Before you start your application',
    atLeast18: 'You must be at least 18 years old',
    validInfo: 'Have a valid email address and NZ mobile number',
    residentInfo: 'Be a citizen or reside in New Zealand (for at least the next 12 months)',
    passportOrDriverLicence: 'E.g. NZ drivers licence, NZ Passport, International Passport',
    proofOfIncome: 'E.g. sharing your bank statement online or uploading documents',
    showLivingExpensesAndUtilitiesInfo: true,
    groupLFrameCardImage: groupLFrameCardImageNZ,
    groupLFrameCardImageMobile: groupLFrameCardImageMobileNZ,
    productInfo: <ProductInfo country="NZ" />,
  },
};

function ProductInfo({ country }) {
  const [states] = useStoreValue();
  const { trackEvent, getQueryString } = useEventTracking();

  const trackEventSender = label => {
    trackEvent({
      event: {
        category: 'text-link',
        action: 'internal-link',
        location: 'what-to-expect',
        label,
      },
      ...getDataLayerElements(states),
    });
  };

  const getLinkWithAnalytics = key => {
    const gemid2 = getQueryString({
      event: {
        category: 'text-link',
        action: 'internal-link',
        location: 'what-to-expect',
        label: key.label,
      },
    });

    const link = new URL(key.url);
    link.searchParams.set('gemid2', gemid2);
    return link.href;
  };
  if (country === 'NZ') {
    const initialDisclosureStatement = OverviewSources.NZ.initial_disclosure_statement_FY2023_Q3;
    return (
      <List>
        <List.Item>
          Read our{' '}
          <Link
            href={getLinkWithAnalytics(OverviewSources.NZ.privacy_acknowledgement_and_authorisation)}
            newTab
            onClick={() => trackEventSender(OverviewSources.NZ.privacy_acknowledgement_and_authorisation.label)}
          >
            {OverviewSources.NZ.privacy_acknowledgement_and_authorisation.label}
          </Link>{' '}
          statement about how we will use the information we collect in this application process
        </List.Item>
        <List.Item>
          Read and understood that the{' '}
          <Link
            href={getLinkWithAnalytics(OverviewSources.NZ.gem_visa_conditions_of_use)}
            newTab
            onClick={() => trackEventSender(OverviewSources.NZ.gem_visa_conditions_of_use.label)}
          >
            {OverviewSources.NZ.gem_visa_conditions_of_use.label}
          </Link>{' '}
          and{' '}
          <Link
            href={getLinkWithAnalytics(initialDisclosureStatement)}
            newTab
            onClick={() => trackEventSender(initialDisclosureStatement.label)}
          >
            {initialDisclosureStatement.label}
          </Link>{' '}
          form the credit contract you as a Gem Visa customer and us.
        </List.Item>
      </List>
    );
  }

  if (country === 'AU') {
    return (
      <>
        <Text margin="3 0">By starting your application you agree to:</Text>
        <List>
          <List.Item>
            The{' '}
            <Link
              href={getLinkWithAnalytics(OverviewSources.AU.latitude_gem_visa)}
              newTab
              onClick={() => trackEventSender(OverviewSources.AU.latitude_gem_visa.label)}
            >
              {OverviewSources.AU.latitude_gem_visa.label}
            </Link>{' '}
            meets your key credit card requirements
          </List.Item>
          <List.Item>
            Have read and understood the Privacy Notice,{' '}
            <Link
              href={getLinkWithAnalytics(OverviewSources.AU.key_facts_sheet)}
              newTab
              onClick={() => trackEventSender(OverviewSources.AU.key_facts_sheet.label)}
            >
              {OverviewSources.AU.key_facts_sheet.label}
            </Link>{' '}
            and{' '}
            <Link
              href={getLinkWithAnalytics(OverviewSources.AU.gem_conditions_of_use)}
              newTab
              onClick={() => trackEventSender(OverviewSources.AU.gem_conditions_of_use.label)}
            >
              {OverviewSources.AU.gem_conditions_of_use.label}
            </Link>{' '}
            and Declaration and Credit Application. These documents will provide an understanding of how your personal
            information is used, the product's ket facts and terms and conditions under which this product operates
          </List.Item>
          <List.Item>Let us complete a credit check during your application</List.Item>
          <List.Item>Receive your {getFinancialTableTerm()} and credit documents electronically</List.Item>
          <List.Item>
            Electronic income verification being attempted by our service providers, including Verifier (see Verifier's
            terms of service). If your income can't be verified via these means, you'll be provided an alternative
            option.
          </List.Item>
        </List>
      </>
    );
  }
}
